import localhost from "apis/localhost";
import { JSON_CONTENT_TYPE } from "constants/app";
import { ENTITY_TYPE_PATH } from "constants/entityTypes";
import { validateErrorResponse } from "slices/app/actions/error";

import { setAssignableUsers, setAssignableUsersLoading } from "./assigneesSlice";

const HEADERS = {
  headers: {
    "Content-Type": JSON_CONTENT_TYPE,
  },
};

const assigneesUrl = (entityType, entityId) =>
  `/nextgen/${ENTITY_TYPE_PATH[entityType]}/${entityId}/assignees`;

export const fetchAssignees =
  (entityType, entityId) => async (dispatch) => {
    try {
      const { data } = await localhost.get(
        assigneesUrl(entityType, entityId)
      );
      return data || [];
    } catch (err) {
      dispatch(validateErrorResponse(err));
      return [];
    }
  };

export const addAssignee =
  (entityType, entityId, workspaceUserId, cascade = false) =>
  async (dispatch) => {
    try {
      await localhost.post(
        assigneesUrl(entityType, entityId),
        { workspaceUserId, cascade },
        HEADERS
      );
      return dispatch(fetchAssignees(entityType, entityId));
    } catch (err) {
      dispatch(validateErrorResponse(err));
      throw err;
    }
  };

export const removeAssignee =
  (entityType, entityId, workspaceUserId, cascade = false) =>
  async (dispatch) => {
    try {
      await localhost.delete(
        `${assigneesUrl(entityType, entityId)}/${workspaceUserId}?cascade=${cascade}`
      );
      return dispatch(fetchAssignees(entityType, entityId));
    } catch (err) {
      dispatch(validateErrorResponse(err));
      throw err;
    }
  };

export const fetchAssignableUsers = () => async (dispatch) => {
  dispatch(setAssignableUsersLoading(true));

  try {
    const { data } = await localhost.get("/nextgen/workspace-users");

    dispatch(setAssignableUsers(data || []));
    return data || [];
  } catch (err) {
    dispatch(validateErrorResponse(err));
    return [];
  } finally {
    dispatch(setAssignableUsersLoading(false));
  }
};
